import * as React from "react";
import { useIntl } from "react-intl";
import { CourseIndex, CourseStateTranslationKey, CourseCertificateValidityTranslationKey, GetLocalizedName } from "../../model/Course";
import { GetTranslation } from "../../translations/GetTranslation";
import { ColumnDefinition, CustomGrid } from "../common/customGrid/CustomGrid";
import TranslatedMessage from "../translations/TranslatedMessage";

type CourseGridProps = {
  courses: CourseIndex[];
  onRowClick: (course: CourseIndex) => void;
  onAddClick: () => void;
};

const CourseGrid = (props: CourseGridProps) => {
  const intl = useIntl();
  const { courses, onRowClick, onAddClick } = props;
  const columnsDefinitions: ColumnDefinition<CourseIndex>[] = [
    { 
      columnKey: "name", 
      columnLabel: <TranslatedMessage id="course.field.name" />, 
      cellValue: (_) => GetLocalizedName(_) 
    },
    {
      columnKey: "validity",
      columnLabel: <TranslatedMessage id="course.field.certificateValidity" />,
      cellValue: (_) => (_.certificateValidity ? GetTranslation(intl, CourseCertificateValidityTranslationKey[_.certificateValidity]) : ""),
    },
    {
      columnKey: "status",
      columnLabel: <TranslatedMessage id="common.field.status" />,
      cellValue: (_) => GetTranslation(intl, CourseStateTranslationKey[_.status]),
    },
  ];

  return (
    <CustomGrid<CourseIndex>
      columnDefinitions={columnsDefinitions}
      rows={courses}
      onRowClick={onRowClick}
      rowKey={(_) => _.id}
      addButtonTooltip={<TranslatedMessage id="exam.button.new" />}
      onAddClick={onAddClick}
    />
  );
};

export default CourseGrid;
